import {forwardRef, memo, useEffect, useState} from "react";
import {getImagePathWithTheme, getIntValue, isNumber, isString} from "../../../../../src/utils";
import {KEYS} from "../../keys";
import Global from "../../../../../src/global";

const ChooseFontSize = forwardRef((props:{onFontSizeChange:any,defaultFontSize:any}, ref) => {
    const [fontSize,setFontSize] = useState(16);
    const [isFocus,setIsFocus] = useState(false);


    useEffect(() => {
        if (!props.defaultFontSize){
            setFontSize(16)
        }else{
            if (isString(props.defaultFontSize)){
                setFontSize(getIntValue(props.defaultFontSize));
            }else{
                setFontSize(props.defaultFontSize);
            }
        }

    }, [props.defaultFontSize]);
    return(
        <div className={'flex-row-vertical-center'} onMouseEnter={()=>{
            // setIsFocus(true);
        }} onMouseLeave={()=>{
            // setIsFocus(false);
        }}>
            {/*下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----下面这个本来是input 但是永远获取不到焦点，不能输入了，不知道为什么，不知道为什么----*/}
            <input id={'input-choose-font-size'} style={{border:isFocus?'1px solid var(--primary-color)':'none',
                minWidth:'32px',width:'32px',height:'27px',
                textAlign:'center',borderRadius:'4px',background:'transparent'}}
                   value={`${fontSize}`}
                   onFocus={(e)=>{
                       e.stopPropagation();
                       setIsFocus(true)
                   }}
                   onBlur={(e)=>{
                       setIsFocus(false);
                       const szValue = e.currentTarget.value;
                       let newFont = 0;
                       if (szValue=='' || isNaN(szValue)) {
                           setFontSize(12);
                           newFont = 12;
                       }else {
                           let nValue = getIntValue(szValue);
                           if (nValue < 1) {
                               nValue = 1;
                           }
                           setFontSize(nValue);
                           newFont = nValue;
                       }
                       props.onFontSizeChange(newFont);
                   }}
                   onInput={(e)=>{
                       const szValue = e.currentTarget.value;
                       if (!szValue) {
                           setFontSize('');
                       }
                        if (isNumber(szValue)) {
                            setFontSize(getIntValue(szValue))
                        }
                   }}
                   onMouseDown={(e)=>{
                       e.stopPropagation();
                   }}
                   onKeyDown={(e)=>{
                        if (e.key == KEYS.ENTER) {
                            e.currentTarget.blur();
                        }
                   }}
            ></input>
            <div className={'flex-col ml-2'}>
                <img className={'cursor-pointer iskeeptoopbar'} style={{width:'10px',height:'6px'}} src={getImagePathWithTheme('tra_up.svg', true)} onClick={(event)=>{
                    event.stopPropagation();
                    const newFont = fontSize + 1;
                    setFontSize(newFont);
                    props.onFontSizeChange(newFont);
                }}/>
                <img className={'cursor-pointer iskeeptoopbar'} style={{width:'10px',height:'6px',marginTop:'3px'}} src={getImagePathWithTheme('tra_down.svg', true)} onClick={(event)=>{
                    event.stopPropagation();
                    const newFont = fontSize - 1;
                    setFontSize(newFont);
                    props.onFontSizeChange(newFont);
                }}/>
            </div>
        </div>
    )
})

export default memo(ChooseFontSize);